import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { Watchlist } from './components/Watchlist';
import { Watched } from './components/Watched';
import Add from './components/Add';
import './App.css';
import './lib/font-awesome/css/all.min.css';
import '../home/static/style.css';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ReplyIcon from '@material-ui/icons/Reply';

function App() {
	return (
		<div className="container">
			<Link to={'/'} className="ml-auto p-5"><ReplyIcon className="pb-2" style={{fontSize:'x-large'}}/> <span style={{fontSize:'large'}}>Back</span></Link>
			<div className="inner-content mt-5">
				<Link to="/movieSearch/WatchList">
					<Button color="primary">Watch List</Button>
				</Link>

				<Link to="/movieSearch/Watched">
					<Button color="primary">Watched</Button>
				</Link>

				<Add />
			</div>
		</div>
	);
}

export default App;
